module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Collapse', {
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('Panel', {
    attrs: {
      "name": "open"
    }
  }, [_vm._v("\n      书籍详情\n      "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "formCustom",
    attrs: {
      "inline": true,
      "label-width": "125px",
      "model": _vm.detailInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "别名: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.detailInfo.nickname),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "nickname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "序列号: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ISBN: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.detailInfo.ISBN),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "ISBN", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.ISBN"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适龄: "
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.tagForDetail.age),
      callback: function($$v) {
        _vm.$set(_vm.tagForDetail, "age", $$v)
      },
      expression: "tagForDetail.age"
    }
  }, _vm._l((_vm.tagsForAge), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出版社: "
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "max": 1
    },
    model: {
      value: (_vm.tagForDetail.publisher),
      callback: function($$v) {
        _vm.$set(_vm.tagForDetail, "publisher", $$v)
      },
      expression: "tagForDetail.publisher"
    }
  }, _vm._l((_vm.tagsForPublisher), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      staticStyle: {
        "font-size": "10px"
      },
      attrs: {
        "label": item.id,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "体裁: "
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.tagForDetail.form),
      callback: function($$v) {
        _vm.$set(_vm.tagForDetail, "form", $$v)
      },
      expression: "tagForDetail.form"
    }
  }, _vm._l((_vm.tagsForForm), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型: "
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.tagForDetail.type),
      callback: function($$v) {
        _vm.$set(_vm.tagForDetail, "type", $$v)
      },
      expression: "tagForDetail.type"
    }
  }, _vm._l((_vm.tagsForType), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "页数: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.detailInfo.pageCnt),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "pageCnt", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.pageCnt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "字数: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.detailInfo.wordCnt),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "wordCnt", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.wordCnt"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否母语: "
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "max": 1
    },
    model: {
      value: (_vm.tagForDetail.tongue),
      callback: function($$v) {
        _vm.$set(_vm.tagForDetail, "tongue", $$v)
      },
      expression: "tagForDetail.tongue"
    }
  }, _vm._l((_vm.tagsForTongue), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "YL值: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view',
      "placeholder": (_vm.doWhatTemp == 'edit') ? '填写数值在0.0-10.0范围' : ''
    },
    model: {
      value: (_vm.detailInfo.IDX_YL),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "IDX_YL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.IDX_YL"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "AR值: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view',
      "placeholder": (_vm.doWhatTemp == 'edit') ? '填写数值在0.0-10.0范围' : ''
    },
    model: {
      value: (_vm.detailInfo.IDX_AR),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "IDX_AR", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.IDX_AR"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "蓝思值: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.detailInfo.IDX_LX),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "IDX_LX", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.IDX_LX"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PERC值: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.detailInfo.IDX_PERC),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "IDX_PERC", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.IDX_PERC"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "核心词汇: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view',
      "placeholder": (_vm.doWhatTemp == 'edit') ? '填写数值在50-9999范围' : ''
    },
    model: {
      value: (_vm.detailInfo.vocabulary),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "vocabulary", _vm._n($$v))
      },
      expression: "detailInfo.vocabulary"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CEFR值: "
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "width": "800px"
    },
    model: {
      value: (_vm.detailInfo.IDX_CEFR),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "IDX_CEFR", $$v)
      },
      expression: "detailInfo.IDX_CEFR"
    }
  }, _vm._l((_vm.cefr), function(item) {
    return _c('el-checkbox', {
      key: item,
      attrs: {
        "label": item,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主题: "
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "width": "800px"
    },
    model: {
      value: (_vm.tagForDetail.theme),
      callback: function($$v) {
        _vm.$set(_vm.tagForDetail, "theme", $$v)
      },
      expression: "tagForDetail.theme"
    }
  }, _vm._l((_vm.tagsForTheme), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "获奖信息: "
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "width": "800px"
    },
    model: {
      value: (_vm.tagForDetail.award),
      callback: function($$v) {
        _vm.$set(_vm.tagForDetail, "award", $$v)
      },
      expression: "tagForDetail.award"
    }
  }, _vm._l((_vm.tagsForAward), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id,
        "disabled": _vm.doWhatTemp === 'view'
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.detailInfo.bindAlbum.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "所属专辑: "
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailInfo.bindAlbum,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "专辑ID",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.gotoAlbum(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.id))])]
      }
    }], null, false, 3095406623)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "专辑名称",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.gotoAlbum(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 1440176469)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "上下架状态",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("未上架")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("被下架")]) : _vm._e()]
      }
    }], null, false, 3878842566)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "res_count",
      "label": "内容数量",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "更新时间",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate2")(scope.row.updated_at)))])]
      }
    }], null, false, 3873418277)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "购买链接: "
    }
  }, _vm._l((_vm.detailInfo.buyUrls), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_vm._v("\n              来源:\n              "), _c('el-input', {
      staticStyle: {
        "width": "100px",
        "margin": "0 20px 0 0"
      },
      attrs: {
        "disabled": _vm.doWhatTemp === 'view'
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.name"
      }
    }), _vm._v("链接:\n              "), _c('el-input', {
      staticStyle: {
        "width": "500px"
      },
      attrs: {
        "disabled": _vm.doWhatTemp === 'view'
      },
      model: {
        value: (item.url),
        callback: function($$v) {
          _vm.$set(item, "url", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.url"
      }
    }), _vm._v(" "), (index == _vm.detailInfo.buyUrls.length - 1 && _vm.doWhatTemp != 'view') ? _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": _vm.addBuyUrl
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-add-circle-outline",
        "size": "30",
        "color": "#C5C5C5"
      }
    })], 1) : _vm._e(), _vm._v(" "), (index != _vm.detailInfo.buyUrls.length - 1 && _vm.doWhatTemp != 'view') ? _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.delBuyUrl(index)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-remove-circle-outline",
        "size": "30",
        "color": "#C5C5C5"
      }
    })], 1) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "书籍简介: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "690px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea",
      "disabled": _vm.doWhatTemp === 'view'
    },
    model: {
      value: (_vm.detailInfo.desc),
      callback: function($$v) {
        _vm.$set(_vm.detailInfo, "desc", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "detailInfo.desc"
    }
  })], 1), _vm._v(" "), _c('br')], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37c31be6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/addBook/addBookAginDetail.vue
// module id = 678
// module chunks = 1